import React from 'react';

import { getWorkflowConstants } from '~/common/constants/workflow';
import UserDepartmentSelect from '~/components/Shared/UserDepartmentSelect/UserDepartmentSelect';
import { useIntl } from 'react-intl';

const WorkflowUserDepartmentMultiSelect = (props) => {
  const intl = useIntl();
  const { workflowTicketRoleOptions } = getWorkflowConstants(intl);

  return (
    <UserDepartmentSelect
      enablePortal
      {...props}
      roles={workflowTicketRoleOptions}
    />
  );
};

export default WorkflowUserDepartmentMultiSelect;
